import { render } from "./AdminChurnUsers.vue?vue&type=template&id=66c4c308&scoped=true"
import script from "./AdminChurnUsers.vue?vue&type=script&lang=js"
export * from "./AdminChurnUsers.vue?vue&type=script&lang=js"

import "./AdminChurnUsers.vue?vue&type=style&index=0&id=66c4c308&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c4c308"]])

export default __exports__